<template>
    <div>
        <div class="app-container position-relative mb-5" v-show="!$global.loading">
            <div class="d-flex justify-content-between mt-5">
                <div class="page-title">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">work_outline</v-icon> Mes entreprises <span
                          v-if="totalEntites">({{ totalEntites }})</span>
                        </span>
                </div>

                <div class="d-flex actions-list">
                    <v-menu bottom transition="slide-y-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="default-button" v-on="on"
                                   :disabled="!selectedEntities.length || !totalEntites">
                                Sur la sélection
                                <v-icon>arrow_drop_down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item @click="openTagModal" :disabled="!selectedEntities.length">
                                <v-list-item-title>
                                    Appliquer un tag
                                </v-list-item-title>
                            </v-list-item>

                            <v-list-item @click="openRemoveTagModal" :disabled="!selectedEntities.length">
                                <v-list-item-title>
                                    Retirer un tag
                                </v-list-item-title>
                            </v-list-item>

                            <v-list-item @click="deleteEntities" :disabled="!selectedEntities.length">
                                <v-list-item-title>
                                    Supprimer les entreprises
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu bottom transition="slide-y-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="default-button" v-on="on">
                                Actions
                                <v-icon>arrow_drop_down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item @click="createEntityModal = true">
                                <v-list-item-title>
                                    Créer une entreprise
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>

                        <v-list>
                            <v-list-item @click="prepareExport" :disabled="totalEntites === 0">
                                <v-list-item-title>
                                    Exporter
                                    <div class="badge bg-primary text-white">
                                        <span v-if="selectAll || !selectedEntities.length">{{ totalEntites }}</span>
                                        <span v-else>{{ selectedEntities.length }}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>

            <div class="mt-5 mb-3">
                <v-card>
                    <v-card-title>
                        <entities-filters></entities-filters>

                        <div v-if="selectedEntities.length === options.itemsPerPage"
                             class="text-center w-100 mt-4 entities-count">

                            <div v-if="!selectAll" class="d-flex justify-content-center">
                                <div class="mt-auto mb-auto">
                                    Les <b>{{ selectedEntities.length }}</b> entreprises de cette page sont
                                    sélectionnées.
                                </div>

                                <div>
                                    <v-btn color="primary" text @click="selectAll = true">
                                        Sélectionner les {{ totalEntites }} entreprises
                                    </v-btn>
                                </div>
                            </div>

                            <div v-else class="d-flex justify-content-center">
                                <div class="mt-auto mb-auto">
                                    Les <b>{{ totalEntites }}</b> entreprises de cette recherche sont sélectionnées.
                                </div>

                                <div>
                                    <v-btn color="primary" text @click="clearSelect">
                                        Annuler la sélection
                                    </v-btn>
                                </div>
                            </div>

                        </div>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="entities" show-select :loading="$global.loading"
                                  v-model="selectedEntities" :items-per-page="options.itemsPerPage"
                                  no-data-text="Aucune entreprise" class="elevation-1"
                                  :server-items-length="totalEntites"
                                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :options.sync="options"
                                  :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Entreprise par page',
                                itemsPerPageOptions: [10, 20, 50, 1000]
                            }">

                        <template v-slot:item.name="{ item }">
                            <div v-if="item.name === null">
                                <router-link :to="'/entity/' + encodeUri(item.id)">-</router-link>
                            </div>
                            <div v-else>
                                <router-link :to="'/entity/' + encodeUri(item.id)">{{ item.name }}</router-link>
                            </div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-menu bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>

                                <v-list>
                                    <v-list-item @click="prepareEmailUpdate(item)">
                                        <v-list-item-title>
                                            <v-icon color="primary">edit</v-icon>
                                            Modifier le destinataire
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="deleteEntity(item)">
                                        <v-list-item-title>
                                            <v-icon color="error">delete</v-icon>
                                            Supprimer l'entreprise
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>

        <v-dialog v-model="createEntityModal" persistent max-width="900px">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <div>
                        <span class="headline">Créer une entreprise</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <span class="fw-light fs-6">Vous pourrez ajouter d'autres informations par la suite</span>

                    <v-text-field outlined label="Nom*"
                                  v-model="newEntityName">
                    </v-text-field>

                    <v-text-field outlined label="E-mail destinataire*" :class="{'input-error': !checkEmailFormat}"
                                  v-model="newEntityMail">
                    </v-text-field>

                    <div class="d-flex justify-content-end gap-10 mt-5">
                        <v-btn @click="createEntityModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="createEntity"
                               :disabled="checkNameAndMailValues">
                            CRÉER
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editContactModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Modification du destinataire</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field outlined label="E-mail" clearable v-model="newEmail"
                                  item-text="email" return-object>
                    </v-text-field>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="editContactModal = false">Fermer</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="updateEmail"
                               :disabled="!emailIsValid || newEmail === null || newEmail === ''">
                            Enregistrer
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="tagModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajout de tags</span>
                </v-card-title>

                <v-card-text>
                    <v-combobox outlined label="Tags" multiple chips small-chips :items="tags" item-text="name"
                                @blur="searchTag = ''" deletable-chips :hide-no-data="!searchTag"
                                :search-input.sync="searchTag"
                                v-model="selectedModalTags" return-object>
                    </v-combobox>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn color="error" class="mr-4" @click="tagModal = false">Annuler</v-btn>
                        <v-btn class="default-button" @click="tagEntities" :disabled="selectedModalTags.length === 0">
                            Taguer mes {{ selectedEntities.length }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="removeTagModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Retirer des tags</span>
                </v-card-title>

                <v-card-text>
                    <v-select outlined label="Tags" multiple chips small-chips :items="availableDeletetags"
                              item-text="name" deletable-chips v-model="selectedModalTags" return-object>
                    </v-select>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn color="error" class="mr-4" @click="removeTagModal = false">Annuler</v-btn>
                        <v-btn class="default-button" @click="unTagEntities">
                            Détaguer mes {{ selectedEntities.length }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import _ from "lodash-es"
import EntitiesFilters from "./Filters.vue"
import { mapState, mapMutations } from "vuex"
import * as EmailValidator from "email-validator"
import Confirm from "../tools/Confirm.vue"

export default {
    name: "Entities",
    components: { Confirm, EntitiesFilters },
    data() {
        return {
            headers: [
                {
                    text: "Nom",
                    value: "name",
                    width: "40%",
                },
                {
                    text: "Municipalité",
                    value: "commune.name",
                    width: "30%",
                },
                {
                    text: "Destinataire",
                    value: "contact_email",
                    width: "20%",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                    width: "10%",
                },
            ],
            entities: [],
            selectedEntities: [],
            totalEntites: 0,
            options: { itemsPerPage: 10, page: 1 },
            sortBy: "name",
            sortDesc: false,
            createEntityModal: false,
            newEntityName: null,
            newEntityMail: null,
            editContactModal: false,
            newEmail: null,
            entityToUpdateContact: null,
            selectAll: false,
            loadingExport: false,
            apiUrl: process.env.VUE_APP_API_URL,
            tagModal: false,
            searchTag: null,
            removeTagModal: false,
            selectedModalTags: [],
            availableDeletetags: [],
        }
    },
    methods: {
        ...mapMutations("entitiesFilter", [
            "setCanSearch",
        ]),
        getEntities: _.debounce(function() {
            this.$global.loading = true

            let sortBy = Array.isArray(this.sortBy) ? this.sortBy[0] : this.sortBy
            let sortDesc = Array.isArray(this.sortDesc) ? this.sortDesc[0] : this.sortDesc

            let payload = {
                perPage: this.options.itemsPerPage,
                currentPage: this.options.page,
                search: this.entitiesSearch,
                emailSearch: this.entitiesEmailSearch,
                communes: this.entitiesSelectedCommunes,
                tourismSectors: this.entitiesSelectedTourismSectors,
                tags: this.entitiesSelectedTags,
                sortBy: sortBy,
                sortDesc: sortDesc,
            }

            this.$http.post("auth/sit-entity", payload).then(res => {
                this.entities = res.body.data.sitEntities
                this.totalEntites = res.body.data.sitEntitiesCount

                this.setCanSearch(true)
                this.$global.loading = false
            })
        }, 200),
        encodeUri(id) {
            return btoa(id)
        },
        createEntity() {
            this.$global.loading = true

            let payload = {
                name: this.newEntityName,
                email: this.newEntityMail,
            }

            this.$http.post("auth/sit-entity/create", payload).then(res => {
                if (res.body.success) {
                    this.$global.loading = false
                    this.$router.push("/entity/" + this.encodeUri(res.body.data.sitEntityId))
                }
            })
        },
        deleteEntity(item) {
            this.$refs.confirm.open("Suppression de l'entreprise",
              "Êtes-vous sûr de vouloir supprimer cette entreprise ?",
              { color: "error", cancelColor: "#0b697e", confirmColor: "error" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.delete("auth/sit-entity/" + item.id).then(res => {
                        if (res.body.success) {
                            this.getEntities()
                        }
                    })
                }
            })
        },
        deleteEntities() {
            this.$refs.confirm.open("Suppression d'entreprises",
              "Êtes-vous sûr de vouloir supprimer les entreprises sélectionnées ?",
              { color: "error", cancelColor: "#0b697e", confirmColor: "error" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let payload = {
                        entityIds: this.selectedEntities.map(entity => entity.id),
                    }

                    this.$http.post("auth/sit-entity/delete", payload).then(res => {
                        if (res.body.success) {
                            this.selectedEntities = []
                            this.getEntities()
                        }
                    })
                }
            })
        },
        prepareEmailUpdate(entity) {
            this.newEmail = entity.contact_email
            this.entityToUpdateContact = entity
            this.editContactModal = true
        },
        updateEmail() {
            this.$global.loading = true

            let payload = {
                email: this.newEmail,
                entityId: this.entityToUpdateContact.id,
            }

            this.$http.put("auth/sit-entity/update-email", payload).then(res => {
                if (res.body.success) {
                    this.newEmail = null
                    this.entityToUpdateContact = null
                    this.editContactModal = false
                    this.getEntities()
                }
            })
        },
        clearSelect() {
            this.selectedEntities = []
            this.selectAll = false
        },
        async prepareExport() {
            this.loadingExport = true

            let entitiesIds = await this.getEntitiesIds()

            let payload = {
                entitiesIds: entitiesIds,
            }

            let res = await this.$http.post("auth/sit-entity/export/generate", payload)
            let filename = res.body.data.filename

            this.loadingExport = false

            let a = document.createElement("a")

            a.href = this.apiUrl + "/export-to-xls/" + filename
            a.click()
        },
        async getEntitiesIds() {
            let entitiesIds = []

            if (!this.selectAll && this.selectedEntities.length) {
                entitiesIds = this.selectedEntities.map(entity => entity.id)
            } else {
                let payload = {
                    perPage: this.options.itemsPerPage,
                    currentPage: this.options.page,
                    search: this.entitiesSearch,
                    emailSearch: this.entitiesEmailSearch,
                    communes: this.entitiesSelectedCommunes,
                    tourismSectors: this.entitiesSelectedTourismSectors,
                    tags: this.entitiesSelectedTags,
                    onlyIds: true,
                }

                let res = await this.$http.post("auth/sit-entity", payload)

                entitiesIds = res.body.data.ids

                this.$global.loading = false
            }

            return entitiesIds
        },
        async getTagsFromEntities() {
            let entitiesIds = await this.getEntitiesIds()

            let payload = {
                entitiesIds: entitiesIds,
            }

            let res = await this.$http.post("auth/sit-entity/tags", payload)

            this.$global.loading = false

            return res.body.data.tags
        },
        tagEntities() {
            setTimeout(() => {
                let newTags = []
                let tags = []

                this.selectedModalTags.forEach(tag => {
                    if (typeof tag === "object") {
                        tags.push(tag)
                    } else {
                        newTags.push(tag)
                    }
                })

                let payload = {
                    entitiesIds: this.selectedEntities.map(entity => entity.id),
                    tags: tags,
                    newTags: newTags,
                }

                this.$global.loading = true

                this.$http.post("auth/sit-entity/add-tags", payload).then(() => {
                    this.$global.loading = false

                    this.tagModal = false

                    this.$store.dispatch("account/fetchTags")

                    this.getEntities()
                })
            }, 500)
        },
        unTagEntities() {
            let payload = {
                entitiesIds: this.selectedEntities.map(entity => entity.id),
                tagIds: this.selectedModalTags.map(tag => tag.id),
            }

            this.$global.loading = true

            this.$http.post("auth/sit-entity/untag", payload).then(() => {
                this.$global.loading = false

                this.removeTagModal = false

                this.getEntities()
            })
        },
        async openTagModal() {
            this.selectedModalTags = []
            this.tagModal = true
        },
        async openRemoveTagModal() {
            this.availableDeletetags = await this.getTagsFromEntities()
            this.selectedModalTags = this.availableDeletetags
            this.removeTagModal = true
        },
    },
    computed: {
        ...mapState("entitiesFilter", [
            "entitiesSearch",
            "entitiesSelectedTags",
            "entitiesSelectedCommunes",
            "entitiesSelectedTourismSectors",
            "entitiesEmailSearch",
        ]),
        ...mapState("account", [
            "user",
            "account",
            "tags",
        ]),
        checkNameAndMailValues() {
            return this.newEntityMail === null || this.newEntityMail === "" ||
              this.newEntityName === null || this.newEntityName === "" || !this.checkEmailFormat
        },
        checkEmailFormat() {
            let isValidEmail = true

            if (this.newEntityMail !== null && this.newEntityMail !== "") {
                isValidEmail = EmailValidator.validate(this.newEntityMail)
            }

            return isValidEmail
        },
        emailIsValid() {
            return EmailValidator.validate(this.newEmail)
        },
    },
    watch: {
        options() {
            this.getEntities()
        },
        entitiesSearch() {
            this.options.page = 1
            this.getEntities()
        },
        entitiesEmailSearch() {
            this.options.page = 1
            this.getEntities()
        },
        entitiesSelectedCommunes() {
            this.options.page = 1
            this.getEntities()
        },
        entitiesSelectedTourismSectors() {
            this.options.page = 1
            this.getEntities()
        },
        entitiesSelectedTags() {
            this.options.page = 1
            this.getEntities()
        },
        selectedEntities() {
            if (this.selectedEntities.length !== this.options.itemsPerPage) {
                this.selectAll = false
            }
        },
    },
    created() {
        this.getEntities()

        this.$store.dispatch("account/fetchTags")
    },
}
</script>